import { Routes, Route } from "react-router-dom";
import "./App.css";

// Components
import Register from "./components/Register";
import Login from "./Login";
import ProtectedRoute from "./components/ProtectedRoute";
import Dashboard from "./components/Dashboard";
import EmailVerification from "./components/EmailVerification";
import ForgotPassword from "./components/ForgotPassword";
import ChangePassword from "./components/ChangePassword";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentFailed from "./pages/PaymentFailed";

// Admin Components
import Admin from "./admin/Dashboard";
import Members from "./admin/Members";
import NewMembers from "./admin/NewMembers";
import NewMemberEdit from "./admin/NewMemberEdit";
import NewMemberView from "./admin/NewMemberView";
import MemberEdit from "./admin/MemberEdit";
import MemberView from "./admin/MemberView";


// Member Component
import Member from "./member/Dashboard";
import Profile from "./member/Profile";
import Receipt from "./member/Receipt";
import Payments from "./member/Payments";
import ProfileEdit from "./member/ProfileEdit";
import MemberChangePassword from "./member/ChangePassword";
function App() {
    return (
        <div className="App">
            <Routes>
                {/* Public Routes */}
                <Route path="/login" element={<Login />} />
                <Route path="/" element={<Register />} />
            
                <Route path="/email-verification" element={<EmailVerification />} />
                <Route path="/forgotpassword" element={<ForgotPassword />} />
<Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/failed" element={<PaymentFailed />} />
                {/* Common Protected Routes (Admin + Member) */}
                <Route element={<ProtectedRoute allowedRoles={[2, 3]} />}>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/changepassword" element={<ChangePassword />} />
                </Route>

                {/* Admin Protected Routes */}
                <Route element={<ProtectedRoute allowedRoles={[3]} />}>
                    <Route path="/admin" element={<Admin />} />
                    <Route path="/members" element={<Members />} />
                    <Route path="/new-members" element={<NewMembers />} />
                     <Route path="/new-member-edit/:id" element={<NewMemberEdit />} />
                    <Route path="/new-member-view/:id" element={<NewMemberView />} />
                    <Route path="/member-edit/:id" element={<MemberEdit />} />
                    <Route path="/member-view/:id" element={<MemberView />} />
                  
                </Route>

                {/* Member Protected Routes */}
                <Route element={<ProtectedRoute allowedRoles={[2]} />}>
                    <Route path="/member" element={<Member />} />
                    <Route path="/membership" element={<Profile />} />
                    <Route path="/profile_edit" element={<ProfileEdit />} />
                    <Route path="/change-member-password" element={<MemberChangePassword />} />
                    <Route path="/receipt" element={<Receipt />} />
                    <Route path="/members/receipt" element={<Receipt />} />
                    <Route path="/members/payments" element={<Payments />} />
                </Route>
            </Routes>
        </div>
    );
}

export default App;
